import React, { useState } from "react";
import { updatePassword } from "../services/api"; // adjust path as needed
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import Cookies from "js-cookie";

const Frame = ({ onClose }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const userId = Cookies.get("id");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!oldPassword || !newPassword || !confirmNewPassword) {
      setError("請填寫所有欄位");
      return;
    }
    if (newPassword.length < 8) {
      setError("新密碼需至少8位");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      setError("新密碼與確認密碼不一致");
      return;
    }

    try {
      const res = await updatePassword(oldPassword, newPassword, userId);
      if (res.status === 200) {
        setSuccess("密碼已成功更新");
        setOldPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        setError(res.data.error || "密碼更新失敗");
      }
    } catch (err) {
      setError(err.response?.data?.error || "密碼更新失敗，請稍後再試");
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: { xs: "90vw", sm: "400px", md: "544px" },
        maxWidth: "544px",
        padding: { xs: "20px 16px", sm: "25px 20px", md: "30px 36px" },
        backgroundColor: "#fcf8f3",
        borderRadius: "13.89px",
        maxHeight: "90vh",
        overflow: "auto",
      }}
    >
      <form onSubmit={handleSubmit}>
        <Stack spacing={{ xs: 3, md: 5 }} alignItems="center" width="100%">
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "20px", sm: "24px", md: "26px" },
              color: "#050505",
              textAlign: "center",
            }}
          >
            變更密碼
          </Typography>

          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}

          <Stack width="100%" spacing={1}>
            <Typography
              variant="h6"
              sx={{
                mb: { xs: 0.5, md: 1 },
                fontSize: { xs: "16px", md: "18px" },
                fontWeight: "400",
              }}
            >
              目前密碼
            </Typography>
            <TextField
              fullWidth
              placeholder="8-12位混用大小寫字母和數字密碼"
              type={showOld ? "text" : "password"}
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              InputProps={{
                sx: {
                  bgcolor: "white",
                  borderRadius: "3px",
                  height: { xs: "45px", md: "56px" },
                  fontSize: { xs: "14px", md: "16px" },
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowOld((v) => !v)}
                      edge="end"
                      size="small"
                    >
                      {showOld ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Typography
              variant="h6"
              sx={{
                mb: { xs: 0.5, md: 1 },
                fontSize: { xs: "16px", md: "18px" },
                fontWeight: "400",
              }}
            >
              新密碼
            </Typography>
            <TextField
              fullWidth
              placeholder="8-12位混用大小寫字母和數字密碼"
              type={showNew ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              InputProps={{
                sx: {
                  bgcolor: "white",
                  borderRadius: "3px",
                  height: { xs: "45px", md: "56px" },
                  fontSize: { xs: "14px", md: "16px" },
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowNew((v) => !v)}
                      edge="end"
                      size="small"
                    >
                      {showNew ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Typography
              variant="h6"
              sx={{
                mb: { xs: 0.5, md: 1 },
                fontSize: { xs: "16px", md: "18px" },
                fontWeight: "400",
              }}
            >
              確認新密碼
            </Typography>
            <TextField
              fullWidth
              placeholder="再次輸入新密碼"
              type={showConfirm ? "text" : "password"}
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              InputProps={{
                sx: {
                  bgcolor: "white",
                  borderRadius: "3px",
                  height: { xs: "45px", md: "56px" },
                  fontSize: { xs: "14px", md: "16px" },
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirm((v) => !v)}
                      edge="end"
                      size="small"
                    >
                      {showConfirm ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Box sx={{ height: "10px" }} />

            <Stack spacing={1} width="100%">
              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  height: { xs: "45px", md: "51px" },
                  fontWeight: "600",
                  backgroundColor: "#ffb60c",
                  color: "#050505",
                  borderRadius: "4.17px",
                  textTransform: "none",
                  fontSize: { xs: "14px", md: "16px" },
                  "&:hover": { backgroundColor: "#e6a40b" },
                }}
              >
                確認
              </Button>
              <Button
                variant="text"
                fullWidth
                sx={{
                  height: { xs: "45px", md: "51px" },
                  color: "#969696",
                  fontWeight: "600",
                  borderRadius: "4.17px",
                  textTransform: "none",
                  fontSize: { xs: "14px", md: "16px" },
                }}
                onClick={onClose}
              >
                取消
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </form>
    </Paper>
  );
};

export default Frame;
